import React from "react";
import { Link } from "react-router-dom";

export const BrandLogo = ({ dark = false, className = "" }) => (
  <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <img
      src="/wonderstone-logo.png"
      alt="Wonderstone Mine"
      className="h-9 w-auto rounded-md bg-white p-1 shadow-sm sm:h-10"
    />
    <div className="hidden h-8 w-px bg-slate-300/60 sm:block" />
    <span className={`hidden text-sm font-semibold uppercase tracking-[0.2em] text-amber-600 sm:block`}>
      SMME Supplier<br />Portal
    </span>
  </Link>
);
